import { Frame } from '@exam-management/app-frame';
import { useModals } from '@exam-management/router';
import { styled } from '@shared/components';
import { NavigationHistoryProvider } from '@shared/navigation';
import type { PropsWithChildren } from '@shared/utils';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { ProtectedRoute } from '../containers';

const Main = styled(Frame)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
}));

type BaseLayoutProps = Partial<PropsWithChildren>;

export default function BaseLayout(props: Readonly<BaseLayoutProps>) {
  const { children } = props;
  const modal = useModals();

  useEffect(() => {
    if (modal.current) {
      modal.close();
    }
  }, []);

  return (
    <Main>
      <ProtectedRoute>
        <NavigationHistoryProvider>{children ?? <Outlet />}</NavigationHistoryProvider>
      </ProtectedRoute>
    </Main>
  );
}
